import { ApiKeyFetch } from "api/fetchers/apiKey";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import Page from "components/Page";
import { urlConsultarCodigoError } from "constants/urls";
import useCustomRouter from "hooks/useCustomRouter";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "wrappers/Loading";

const ErrorPage = () => {
  const params = useParams();

  const [state, setState] = useState({});
  const [loading, setLoading] = useState(true);

  const router = useCustomRouter();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    setLoading(true);
    const [grupo, codigo] = params?.errorCode?.split("|");
    try {
      const response = await ApiKeyFetch.instance().post(urlConsultarCodigoError, {
        empCodigo: "AIGMEX",
        grupo,
        codigo,
      });
      console.log(response);
      setState(response);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <div className='cr-content'>
          <Page>
            <main className='cr-content'>
              <Page>
                <BreadCurmb showPaths={false} />
                <div className='row justify-content-center'>
                  <div className='col-12'>
                    <h1 className='display-3 text-mex text-center '>{state?.titulo}</h1>
                  </div>

                  <div className='col-8'>
                    <div className='d-flex justify-content-center text-justify'>
                      <p className='mt-4 font-source-sans-regular' style={{ fontSize: "20px" }}>
                        {state?.descripcion}
                      </p>
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='d-flex justify-content-center'>
                      <button
                        onClick={() => {
                          state?.buttonProps?.redirect && router.push(state?.buttonProps?.redirect);
                        }}
                        className='container-accidentes btn btn-block btn-primary btn-mis-datos text-uppercase col-4'
                        type='submit'>
                        {state?.buttonProps?.label}
                      </button>
                    </div>
                  </div>
                </div>
              </Page>
            </main>
          </Page>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default ErrorPage;
